import { Component, inject, Input, OnInit, signal } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { AdaaHelper } from "../../../../core/utils";
import { Constants } from "../../../constants/constants";
import { ValueText } from "../../../models";
import { KpisApiService } from "../../../services";
import { FormDropdownComponent } from "../../form";

@Component({
  selector: "adaa-kpi-clone-modal",
  imports: [TranslatePipe, ReactiveFormsModule, FormDropdownComponent],
  templateUrl: "./kpi-clone-modal.html",
  styleUrl: "./kpi-clone-modal.scss",
})
export class KpiCloneModalComponent implements OnInit {
  private readonly _translateService = inject(TranslateService);
  private readonly _toastrService = inject(ToastrService);
  private readonly _formbuilder = inject(FormBuilder);
  private readonly _kpisApiService = inject(KpisApiService);
  readonly modal = inject(NgbActiveModal);

  @Input() kpiType: number;
  @Input() header: string;
  @Input() message: string;

  cloneForm: FormGroup;
  cloneToOptions = signal<ValueText[]>([]);

  public ngOnInit(): void {
    this._initForm();
    this._getAvailableCloningType();
  }

  public save() {
    if (this.cloneForm.invalid) {
      this._toastrService.error(this._translateService.instant("notification.warning.missing_info"));
      return;
    }

    this.modal.close(this.cloneForm.get("cloneTo")?.value);
  }

  private _initForm(): void {
    this.cloneForm = this._formbuilder.group({
      cloneTo: [null, Validators.required],
    });
  }

  private _getAvailableCloningType() {
    this._kpisApiService.getAvailableCloningType(this.kpiType).subscribe({
      next: (response) => {
        if (response.inError) return;
        let cloneTo = response.responseData ?? [];

        if (!AdaaHelper.isPMOEntity())
          cloneTo = cloneTo.filter((e) => e.id !== Constants.KPI_TYPE.NTKPI && e.id !== Constants.KPI_TYPE.DTKPI);

        this.cloneToOptions.set(AdaaHelper.setDropdownArray(cloneTo, "id", AdaaHelper.getFieldLanguage("name")));
      },
    });
  }
}
